import React from 'react';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import { EcoCompareSelectorItemType } from 'eco-design/sections/eco-compare-selector/type';
import EcoSpace from 'eco-design/base/eco-space';
import EcoCompareSelector from 'eco-design/sections/eco-compare-selector';
import { GeneralKeys_JP_V2_StatusC, GeneralKeys_JP_V2_StatusD } from '../../../../config/pageConfig';
import { useProductStore } from '../../../../ProductProvider';
import { useSpec } from './useSpec';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import { useScheduledContent } from '@/utils/hooks/useScheduledContent';

const JP_KEYS = [
    'Capacity',
    'specs_ports',
    'specs_wired_charging_input',
    'specs_wired_charging_output',
    'rapid_wireless_output',
    'specs_app',
    'specs_digital_display',
    'rapid_dimensions',
    'rapid_weight',
    'specs_color',
];

// 颜色映射对象
const colorMap = {
    black: '#212121',
    silver: '#cdcdcd',
    blue: '#c0defe',
    white: '#e2e2df',
    purple: '#b5b2e3',
    green: '#a6cba1',
    pink: '#f3caa8',
};

const CompareSelector: React.FC = ({}) => {
    const { t } = useLang('theProductV2.CompareSelector');
    const { productInfo, pageStatus } = useProductStore();
    const { locale = 'jp' } = getLocal();

    const IS_JP = locale === 'jp';
    // 获取「比较参数」
    const subs = useSpec(pageStatus === 'statusC' ? GeneralKeys_JP_V2_StatusC : GeneralKeys_JP_V2_StatusD, JP_KEYS);

    const isBuy = useScheduledContent({
            '2025/12/26 11:00:00 GMT+8': true,
            '2025/12/09 11:00:00 GMT+8': true,
            '2025/12/12 11:00:00 GMT+8': false,
        })
    // 整合数据
    const item = productInfo?.map((i, idx) => {
        let title = i.children?.find((child) => child?.productTitle)?.productTitle || '';
        return {
            label: idx < 2 ? t('new') : t('old'),
            title,
            items: productInfo?.map((j) => ({
                label: j.children[0].productTitle,
                value: j.children[0].productTitle,
            })),
            colors: i.children?.map((j, idx2) => ({
                ...j,
                color: colorMap[j.name as 'black'],
                btns: [
                    {
                        className: `GtmModuleData-btn-href buy-${idx}-${idx2}`,
                        href: i.show === pageStatus && !isBuy?`https://${locale}.ecoflow.com/products/${j?.handle}?variant=${j?.variantId}`:`https://${locale}.ecoflow.com/cart/${j.variantId}:1?channel=buy_button`,
                        text: IS_JP && j.lDisabled ? t('buynow2') :  IS_JP && i.show === pageStatus&&!isBuy? t('presaleNow'):t('buynow'),
                        type: 'filled',
                        dataLayer: {
                            event: 'uaEvent',
                            event_name: 'checkout',
                            button_name: `${t('buynow')}_${title}`,

                            __btn_id1: `CompareSelector .buy-${idx}-${idx2}`,
                            __btn_id2: `https://${locale}.ecoflow.com/cart/${j.variantId}:1?channel=buy_button`,
                            __btn_type: 'href',
                        },
                        disabled: j.lDisabled,
                    },
                    t('more') &&
                        !j.lDisabled && {
                            className: `GtmModuleData-btn-href more-${idx}-${idx2}`,
                            href: `https://${locale}.ecoflow.com/products/${j.handle}?variant=${j.variantId}`,
                            text: t('more'),
                            type: 'text',
                            icon: true,
                            dataLayer: {
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: title,
                                position: `Collections_${t('title')}`,

                                __btn_id1: `CompareSelector .more-${idx}-${idx2}`,
                                __btn_id2: `https://${locale}.ecoflow.com/products/${j.handle}?variant=${j.variantId}`,
                                __btn_type: 'href',
                            },
                        },
                ],
            })),
            subs: subs[idx] ?? [],
        };
    });

    if (!productInfo) return <div id="CompareSelector"></div>;

    return (
        <section
            className={`GtmModuleData-section CompareSelector ${style.comp}`}
            id="CompareSelector"
            data-section-id="CompareSelector"
            data-section-title={t('title')}
        >
            <EcoSpace />
            <EcoCompareSelector
                className="spec-comp"
                title={t('title')}
                linkProps={{
                    className: 'GtmModuleData-btn-common title-link',
                    'data-btn-id': 'CompareSelector-link',
                    dataLayer: {
                        event: 'uaEvent',
                        event_name: 'buy',
                        product_name: 'EcoFlow RAPID Mag',
                        position: `Collections_${t('link')}`,

                        __btn_id1: `CompareSelector .title-link`,
                        __btn_id2: `CompareSelector-link`,
                        __btn_type: 'common',
                    },
                    href: `https://${locale}.ecoflow.com/collections/power-bank#rapid-mag`,
                    children: (
                        <>
                            <span>{t('link')}</span>
                            <EcoIconArrow />
                        </>
                    ),
                }}
                items={item as EcoCompareSelectorItemType[]}
            />
        </section>
    );
};
export default CompareSelector;
